import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api, type Paginated } from '@/lib/api';

export interface TastingEvent {
  id: number;
  name: string;
  location: string | null;
  event_date: string;
  notes: string | null;
  tasting_notes_count?: number;
  created_at: string;
}

export function useTastingEvents(params: { date?: string } = {}) {
  return useQuery({
    queryKey: ['tasting-events', params],
    queryFn: async () => {
      const { data } = await api.get<Paginated<TastingEvent>>('/tasting-events', { params });
      return data.data;
    },
  });
}

export function useCreateTastingEvent() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (payload: Omit<TastingEvent, 'id' | 'created_at' | 'tasting_notes_count'>) => {
      const { data } = await api.post<{ data: TastingEvent }>('/tasting-events', payload);
      return data.data;
    },
    onSuccess: () => qc.invalidateQueries({ queryKey: ['tasting-events'] }),
  });
}
